<google-chart #lineChart [type]="chartType" [data]="myData" [columns]="columnNames" 
    [options]="procurementOptions"
    [style]="cStyle"></google-chart>